module.exports = __webpack_public_path__ + "static/AngelaHe8-fa854f8196aef0e9057f78c9d4aa3178.png";